function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import ListItem from '../../listItem/ListItem';

var BaseLink =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(BaseLink, _React$PureComponent);

  function BaseLink() {
    _classCallCheck(this, BaseLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaseLink).apply(this, arguments));
  }

  _createClass(BaseLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isTentativelySelected) {
        this._focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var hasDropdownFocus = this.props.isTentativelySelected;

      if (hasDropdownFocus !== null) {
        if (hasDropdownFocus) {
          this._focus();
        } else {
          this._blur();
        }
      }
    }
  }, {
    key: "_getRef",
    value: function _getRef(ref) {
      this._link = ref;
      return this._link;
    }
  }, {
    key: "_blur",
    value: function _blur() {
      if (this._link) {
        this._link.blur();
      }
    }
  }, {
    key: "_focus",
    value: function _focus() {
      if (this._link) {
        this._link.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          LinkComponent = _this$props.LinkComponent,
          children = _this$props.children,
          iconType = _this$props.iconType,
          iconSize = _this$props.iconSize,
          iconColor = _this$props.iconColor,
          iconStrokeColor = _this$props.iconStrokeColor,
          imageUrl = _this$props.imageUrl,
          imageAlt = _this$props.imageAlt,
          isSquareImage = _this$props.isSquareImage,
          verticalAlignment = _this$props.verticalAlignment,
          active = _this$props.active,
          useAltTheme = _this$props.useAltTheme,
          isDisabled = _this$props.isDisabled,
          isTentativelySelected = _this$props.isTentativelySelected,
          showStatus = _this$props.showStatus,
          statusText = _this$props.statusText,
          extraProps = _objectWithoutProperties(_this$props, ["LinkComponent", "children", "iconType", "iconSize", "iconColor", "iconStrokeColor", "imageUrl", "imageAlt", "isSquareImage", "verticalAlignment", "active", "useAltTheme", "isDisabled", "isTentativelySelected", "showStatus", "statusText"]);

      var linkProps = _.omit(extraProps, ['onActivate', 'showStatus', 'statusText']);

      var className = classNames('eds-nav-list-item', 'eds-nav-list-item--link', {
        'eds-nav-list-item--selected': active,
        'eds-nav-list-item--alt-theme': useAltTheme,
        'eds-nav-list-item--tentatively-selected': isTentativelySelected,
        'eds-nav-list-item--disabled': isDisabled
      });
      var Component = LinkComponent;

      var _getRef;

      if (Component === 'a') {
        _getRef = this._getRef.bind(this);
      } // if the link is disabled, just render a span tag instead!


      if (isDisabled) {
        Component = 'span';
        linkProps = {};
      }

      return React.createElement(Component, _extends({}, linkProps, {
        className: className,
        ref: _getRef
      }), React.createElement(ListItem, {
        iconType: iconType,
        iconSize: iconSize,
        iconColor: iconColor,
        iconStrokeColor: iconStrokeColor,
        imageUrl: imageUrl,
        imageAlt: imageAlt,
        isSquareImage: isSquareImage,
        verticalAlignment: verticalAlignment,
        isSelected: active,
        useAltTheme: useAltTheme,
        isDisabled: isDisabled,
        showStatus: showStatus,
        statusText: statusText
      }, children));
    }
  }]);

  return BaseLink;
}(React.PureComponent);

export { BaseLink as default };